import { TFunction } from 'i18next';
import React from 'react';
import UnderwritingComponent from 'components/features/contract/underwriting';
import PremiumProcessingComponent from 'components/features/contract/premium-processing';
import EndorsementsComponent from 'components/features/contract/endorsements';
import DocumentsComponent from 'components/features/contract/documents';
import { ContractResponseDto } from 'libs/pinnacle-sdk';

export interface ContractTabProps {
  contract?: ContractResponseDto;
  includeNext: boolean;
  includeBack: boolean;
  navigateNext: () => void;
  navigateBack: () => void;
}

export const getContractConfigTabs = (t: TFunction) => [
  {
    id: 0,
    tab: t('contract.underwriting'),
    component: UnderwritingComponent,
  },
  {
    id: 1,
    tab: t('contract.premiumProcessing'),
    component: PremiumProcessingComponent,
  },
  /**
   * "Endorsements" tab contains adjustment history
   */
  {
    id: 2,
    tab: t('contract.endorsements'),
    component: EndorsementsComponent,
  },
  {
    id: 3,
    tab: t('contract.documents'),
    component: DocumentsComponent,
  },
];

export const getComponentByTabId = (
  tabId: number | string,
  t: TFunction
): React.FC<ContractTabProps> => {
  const configTabs = getContractConfigTabs(t);
  const tab = configTabs.find((tab) => tab.id === tabId);
  return tab ? tab.component : configTabs[0].component;
};
